import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './patient.module.scss';
import  { ApiCore } from '../../api/index';
import { Space, Swiper } from 'antd-mobile-v5';
import { Tabs, List, ListView, PullToRefresh } from 'antd-mobile';
import patient_head_card_bg from '../../static/images_doctor/patient_head_card_bg.png';
import patient_avatar from '../../static/images_doctor/patient_avatar.png';
import icon_search from '../../static/images_doctor/tool_introdce_search.png';
import no_patient from '../../static/images_doctor/no_patient.png';
import icon_search_clear from '../../static/images_medicalLive/search_clear.png';

const api = new ApiCore();

const colors = ['#ace0ff', '#bcffbd', '#e4fabd', '#ffcfac'];

let delayExcute:any = null;

function Personal(props: any) {

    const [userName, setUserName] = useState('');
    const [searchTitle, setSearchTitle] = useState<any>(null);
    const [patientList, setPatientList] = useState([]);
    const [patientTabList, setPatientTabList] = useState([]);
    const [patientTabMap, setPatientTabMap] = useState({});
    const [groupList, setGroupList] = useState([]);
    const [tabPage, setTabPage] = useState(0);

    // 上拉加载与下拉刷新
    const [isPullToRefresh, setIsPullToRefresh] = useState<boolean>(false); // 下拉刷新状态
    const [isMore, setIsMore] = useState<boolean>(true); // 是否还有更多数据
    const [curPage, setCurPage] = useState<number>(1); // 当前加载的页数
    const [curPageSize, setCurPageSize] = useState<number>(10); // 分页条数
    const [total, setTotal] = useState<number>(10); // 总条数
    const [listReady, setListReady] = useState(false);
    const [listLoading, setListLoading] = useState(false);
    // 设置加载状态
    const [loading, setLoading] = useState<any>(null);
    // 是否加载更多
    const [isLoadingMore, setIsLoadingMore] = useState(true);

    useEffect(() => {
        document.title = '我的患者';
        initData();
        return () => {
        }
    }, [])

    useEffect(() => {
        clearTimeout(delayExcute);
        if (searchTitle !== null) {
            setListReady(false);
            setCurPage(1);
            setTotal(10);
            if (tabPage != 0) {
                // 搜索至于全部选项
                setPatientList([]);
                setTabPage(0);
            }
            delayExcute = setTimeout(() => {
                initListData(searchTitle);
            }, 300);
        }
    }, [searchTitle])

    const history = useHistory();

    const initData = () => {
        api.getGroupSelfList().then((res: any) => {
            if (res.code == 0) {
                setGroupList(res.data || []);
            }
        });
        api.getCaseStateEnums().then((res: any) => {
            if (res.code == 0) {
                let _tabs = res.data || [];
                const _tabsMap = {};
                const _mTabs = ['建档中', '待审核', '待知情', '随访中', '临期', '已失访' , '已完成']; // '已转诊' '转归'
                let _mMTabs: any = [];
                _tabs = _tabs.map((val: any) => {
                    _tabsMap[val.code] = val.name;
                    const mTabIndex = _mTabs.indexOf(val.name);
                    _mMTabs[mTabIndex] = {
                        ...val,
                        title: val.name
                    }
                    return {
                        ...val,
                        title: val.name
                    }
                });
                _tabs.unshift({
                    code: '',
                    name: '全部',
                    title: '全部'
                });
                _mMTabs.unshift({
                    code: '',
                    name: '全部',
                    title: '全部'
                });
                // 顺序调整
                setPatientTabList(_mMTabs || []); // _tabs
                setPatientTabMap(_tabsMap);
                sessionStorage.setItem('PatientStateMap', JSON.stringify(_tabsMap));
            }
        });

        initListData();

    }

    const initListData = (patientName = '') => {
        setListReady(false);
        api.getCasePage({
            page: 1,
            pageSize: 10,
            state: '',
            patientName: patientName
        }).then((res: any) => {
            if (res.code == 0) {
                setPatientList(res.data.rows || []);
                setTotal(res.data.total);
                setListReady(true);
                setPatientList(res.data.rows);
                setTotal(res.data.total);
                const _isMore = (res.data.total > 10);
                setIsMore(_isMore);
            }
        });
    }

    // 搜索标题变化
    const titleInput = (event: any) => {
        setSearchTitle(event.target.value);
    }

    // 清除输入内容
    const clearInput = () => {
        setSearchTitle('');
    }

    const groupListItemClick = (value: any) => {
    }

    const toolIntroduceClick = (index: any, tab: any) => {
        setTabPage(index);
        setCurPage(1);
        api.getCasePage({
            page: 1,
            pageSize: 10,
            state: tab.code
        }).then((res: any) => {
            if (res.code == 0) {
                let _rows = (res.data?.rows || []);
                setPatientList(_rows);
                setIsMore(res.data.total > 10);
            }
        });
    }

    const lookAll = (val: any) => {
        history.push(`/crf?caseCode=${val.caseCode}&urlType=patientHome`);
    }

    const addPatient = (val: any) => {
        history.push(`/doctor/addPatientManually`);
    }

    const items = groupList.map((value: any, key) => (
        <Swiper.Item key={key} onClick={() => { groupListItemClick(value) }}>
          <div className={styles.loop_container} style={{ width: groupList.length == 1 ? '64.07%' : '' }}>
            {
                groupList.length > 1 &&
                <div className={styles.loop_text}></div>
            }
            <div className={styles.loop_img} style={{backgroundImage: `url(${patient_head_card_bg})`, backgroundSize: '100% 100%'}}>
                <div className={styles.loop_title}>
                    {value.groupName}
                </div>
                <div className={styles.loop_content}>
                    <span className={styles.loop_content_left}>{value.enablePatientLabel ? '(NP / OP)' : '患者总数'}</span>
                    <span className={styles.loop_content_right}>{value.enablePatientLabel ? `${value.npNum} / ${value.opNum}` : value.totalNum}</span>
                </div>
            </div>
            {
                groupList.length === 1 &&
                <div className={styles.loop_text}></div>
            }
          </div>
        </Swiper.Item>
    ))

    const dataView = new ListView.DataSource({
        rowHasChanged: (row1: any, row2: any) => row1 !== row2,
    });

    const dataSource = dataView.cloneWithRows(patientList);

    // 下拉加载
    const onPullToRefresh = () => {
        setIsPullToRefresh(true);
        // 重置状态
        setListReady(false);
        setLoading(true);
        setCurPage(1);
        setListLoading(true);
        api.getCasePage({
            patientName: searchTitle,
            page: 1,
            pageSize: 10,
            // @ts-ignore
            state: patientTabList[tabPage].code,
        }).then((res: any) => {
            if (res.code == 0) {
                let _list = (res.data && res.data.rows) || [];
                setPatientList(_list);
                setTotal(res.data.total);
                setLoading(false);
                setListReady(true);
                setIsPullToRefresh(false);
                setListLoading(false);
                setIsMore(res.data.total > 10);
            }
        })
    }

    // 触底上拉刷新
    const onEndListAdded = () => {
        setListReady(false);
        setListLoading(true);
        let nowPage = curPage;
        if (total <= 10) {
            // 没有更多
            setIsMore(false);
            setListLoading(false);
            return;
        } else if (nowPage * curPageSize > total) {
            // 超出分页总数据后不再加载
            setIsMore(false);
            setListLoading(false);
            return;
        } else {
            setIsMore(true);
            setListLoading(true);
        }
        nowPage++;
        setCurPage(nowPage);
        api.getCasePage({
            patientName: searchTitle,
            page: nowPage,
            pageSize: 10,
            // @ts-ignore
            state: patientTabList[tabPage].code,
        }).then((res: any) => {
            setTimeout(() => {
                setListLoading(false);
                if (res.code == 0) {
                    setPatientList(patientList.concat(res.data && res.data.rows) || []);
                    setTotal(res.data.total);
                }
                setListReady(true);
                setIsPullToRefresh(false);
            }, 375);
        });
    }

    // 上拉触底
    const onEndReached = () => {
        if (isMore) {
            //加载数据
            onEndListAdded()
        }
    }

    const row = (val: any, index: any) => (
        <div className={`${styles.list_container}`} key={index} onClick={() => { lookAll(val) }}>
            <div className={`${styles.list_container_left} ${styles.list_container_left_avatar}`}>
                    <img src={patient_avatar} alt="" />
            </div>
            <div className={`${styles.list_container_middle}`}>
                <div className={`${styles.list_container_middle_top}`}>
                    <span className={`${styles.list_container_middle_top_title}`}>{val.patientName}</span>
                    {
                        val.patientLabel && 
                        <span className={`${val.patientLabel === 'NP' ? styles.list_container_middle_top_np : styles.list_container_middle_top_op}`}>{val.patientLabel}</span>
                    }
                </div>
                <div className={`${styles.list_container_middle_bottom}`}>
                    {val.groupName}
                </div>
            </div>
            <div className={`${styles.list_container_right}`}>
                {
                    val.state >= 0 &&
                    <span className={`${styles.followup_ing}`}>{patientTabMap[val.state]}</span>
                }
                {/* <span className={`${styles.remain_to_know}`}>待知情</span> */}
            </div>
        </div>
    );

    const _listView = 
    <ListView
        style={{ height: '12rem', backgroundColor: '#FFFFFF'}}
        className={styles.listview}
        dataSource={dataSource}
        renderRow={row}
        initialListSize={2000}
        onEndReached={onEndReached}
        onEndReachedThreshold={6}
        scrollRenderAheadDistance={500}
        scrollEventThrottle={200}
        useBodyScroll={false}
        // pullToRefresh={
        //     <PullToRefresh
        //         damping={60}
        //         distanceToRefresh={25}
        //         indicator={{}}
        //         direction="down"
        //         refreshing={isPullToRefresh}
        //         getScrollContainer={() => undefined}
        //         onRefresh={() => {
        //             onPullToRefresh()
        //         }}
        //     >
        //     </PullToRefresh>
        // }
        renderFooter={() => (
        <div style={{ textAlign: 'center' }} onClick={() => { onEndReached() }}>
            {listLoading ? '正在加载...' : isMore ? '查看更多' : '暂无更多'} 
        </div>)}
    />;

    return (
        <div className={`${styles.patient_content}`}>
            <div className={`${styles.patient_head}`}>
                <div className={`${styles.patient_head_left}`}>患者分组</div>
                {/* <div className={`${styles.patient_head_right}`} onClick={lookAll}>查看全部</div> */}
            </div>
            <div className={`${styles.head_swiper_container}`}>
                <Swiper
                    trackOffset={0}
                    slideSize={groupList.length > 1 ? 61.3 : 95.73}
                    // slideSize={61.3}
                    style={{
                    '--border-radius': '0px',
                    '--track-padding': ' 0 0 18px'
                    }}
                    stuckAtBoundary={true}
                    defaultIndex={0}
                >
                    {items}
                </Swiper>
            </div>
            <div className={`${styles.patient_gap}`}></div>
            <div className={`${styles.list_head_container}`}>
                <div className={`${styles.patient_head}  ${styles.list_container_head}`}>
                    <div className={`${styles.patient_head_left} ${styles.patient_word}`}>患者列表</div>
                    <div className={`${styles.patient_head_right} ${styles.add_patient}`} onClick={addPatient}><span></span> 添加患者</div>
                </div>
            </div>
            <div className={`${styles.tool_introduce_head}`}>
                    <div className={styles.search_head}>
                        <div className={styles.search}>
                            <img className={styles.search_img} src={icon_search} alt="" />
                            <input type="text" placeholder="输入患者姓名进行查找" value={searchTitle} onChange={(event) => { titleInput(event) }} />
                            {
                                searchTitle &&
                                <img className={`${styles.search_img_clear}`} src={icon_search_clear} alt="" onClick={ () => { clearInput() }} />
                            }
                        </div>
                    </div>
                    {/* <div className={`${styles.tool_introduce_head_text}`}>筛选</div> */}
            </div>
            { patientTabList && patientTabList.length > 0 &&
                <Tabs tabs={patientTabList}
                    initialPage={0}
                    page={tabPage}
                    swipeable={false}
                    onTabClick={(tab, index) => { toolIntroduceClick(index, tab); }}
                    tabBarUnderlineStyle={{ display: 'none' }}
                >
                    {
                        patientTabList.map(val => {
                            if (patientList.length === 0) {
                                return (
                                    <div className={`${styles.list_no_patient}`}>
                                        <img src={no_patient} alt="" />
                                    </div>
                                );
                            } else {
                                return _listView;
                            }
                        }
                        )
                    }
                </Tabs>
            }
        </div>
    )

}

export default Personal;